'use client';
import { LINKS } from '@/app/utils/constant';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import Link from 'next/link';
import React from 'react';

export const Empty = () => {
  const { t } = useLang(NAMESPACE.cart);
  const { t: commonT } = useLang(NAMESPACE.common);

  return (
    <div className="w-full h-52 flex justify-center items-center sm:flex-col">
      <span className="text-base text-gray-[#4a4a4a] font-semibold">{t('empty.text')}</span>
      <Link
        href={LINKS.homepage}
        className="p-0 text-left flex items-center justify-self-end h-6 ml-2 text-base font-semibold"
      >
        {commonT('continue.shopping')}
      </Link>
    </div>
  );
};
